// use webpack require.context to dynamically load translations from files
const markdownFromModule = mod => {
  if (mod == null) return ''
  return typeof mod === 'string' ? mod : mod.default ?? ''
}

const newestTranslations = req =>
  req.keys().reduce((acc, key) => {
    // filenames (keys) format: EULA-candidate.<lc>.<YYYY-MM-DD>.md
    const [lc, date] = key.split('.').slice(2, 4)
    if (!(acc[lc] && acc[lc].date > date))
      acc[lc] = {
        markdown: markdownFromModule(req(key)),
        date,
      }
    return acc
  }, {})

const translations = newestTranslations(
  // Webpack parses for require.context() in the code while building.
  require.context('../../../i18n/', false, /EULA-candidate.*\.md$/),
)

// Object with date, language code and markdown of latest license texts
// {'lc': {date: 'YYYY-MM-DD', markdown: '[raw markdown]'}}
export default translations
